import React from "react";
import { useNavigate } from "react-router-dom";
import selfImage from "./images/self.webp";
import instaLogo from "./images/insta.webp";
import facebookLogo from "./images/facebook.webp";
import googlePlayLogo from "./images/googleplay.webp";
import appStoreBadge from "./images/appstore.webp";
import logo from './images/logo.webp';
import "./AppInfo.css";
import { Helmet } from 'react-helmet';

const AppInfo = () => {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>TKD Study - App Info</title>
      </Helmet>
      <div className="back-arrow" onClick={() => navigate('/')}>
        ← Back
      </div>

      <div className="app-info-container">
        <div className="content-image-wrapper">
          <div className="text-section">
            <p>
              <b>About TKD Study</b><br />
              TKD Study started as  side project to develop my coding and programming skills. It turned into a great way 
              for me to learn the theory of Taekwondo so I continued working on the Android App. 
              I shared the app world wide but due to limitations could not reach the Apple audience, this when I decided to work 
              on the web version for desktop and Apple users. 
              <br /><br />
              TKD Study is meant to be an education aid for the theory of ITF Taekwondo. Practice in class and listen to your instructors.
              At home use TKD Study to build upon your foundation of Taekwondo.
              <br /><br />
              <b>Who am I?</b><br />
              I began partaking in Taekwondo in 2016 with Legacy Taekwondo Drogheda under instructors
              Mr. Paul Floody VI and Mr. Niall Reynolds V.
              <br /><br />
              I have since obtained my 1st Dan within the International Taekwondo Federation and Irish National Taekwondo Association in 2021 and my 2nd Dan in 2025
              <br /><br />
              I currently train under Ms. Joan Wiseman IV and Mr. Brian Kenny III at Legacy Taekwondo.
              <br /><br />
              Special thanks to Niall Reynolds V, Joan Wiseman IV, and Brian Kenny III for their support and guidance.
            </p>
            <img src={logo} alt="App Logo" className="app-logo" />
          </div>

          <img src={selfImage} alt="Self Portrait" className="self-image" />
        </div>

        <div className="buttons-section">
          <button
            onClick={() => window.open("https://forms.gle/gejTqWo47tTXnNk7A", "_blank")}
          >
            Contact
          </button>
          <button
            onClick={() => window.open("https://cyo-labs.web.app/privacy", "_blank")}
          >
            Privacy Policy
          </button>
          <button
            onClick={() => window.open("https://cyo-labs.web.app/tos", "_blank")}
          >
            Terms of Use
          </button>
        </div>

        <div className="social-icons">
          <img
            src={instaLogo}
            alt="Instagram Logo"
            className="social-icon"
            onClick={() =>
              window.open("https://www.instagram.com/tkdstudyapp/", "_blank")
            }
          />

          <img
            src={facebookLogo}
            alt="Facebook Logo"
            className="social-icon"
            onClick={() =>
              window.open(
                "https://www.facebook.com/profile.php?id=61575841055382",
                "_blank"
              )
            }
          />

          <img
            src={googlePlayLogo}
            alt="Google Play Badge"
            className="store-badge"
            onClick={() =>
              window.open(
                "https://play.google.com/store/apps/details?id=com.tkd.app&pcampaignid=web_share",
                "_blank"
              )
            }
          />

          <img
            src={appStoreBadge}
            alt="App Store Badge"
            className="store-badge"
            onClick={() =>
              window.open(
                "https://apps.apple.com/us/app/tkd-study-itf-taekwondo/id6774597426",
                "_blank"
              )
            }
          />
        </div>

        <div className="version-number">Web Release 3.1 08/06/26</div>
      </div>
    </>
  );
};

export default AppInfo;
